// Date helpers for metrics tables that use DATE columns.
// We avoid Date#toISOString() because it can shift the calendar day based on timezone.

export const pad2 = (n) => String(n).padStart(2, '0')

// Format a JS Date (local time) to YYYY-MM-DD.
export const formatDateToYMD = (date) => {
  if (!date) return ''
  const d = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(d.getTime())) return ''

  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

// Parse YYYY-MM-DD into a JS Date in local time.
export const parseYMDToDate = (ymd) => {
  if (!ymd || typeof ymd !== 'string') return null
  const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(ymd)
  if (!m) return null
  const year = Number(m[1])
  const month = Number(m[2])
  const day = Number(m[3])
  const d = new Date(year, month - 1, day)
  return Number.isNaN(d.getTime()) ? null : d
}

export const startOfDay = (date) => {
  const d = date instanceof Date ? new Date(date) : new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

export const addDays = (date, days) => {
  const d = date instanceof Date ? new Date(date) : new Date(date)
  d.setDate(d.getDate() + days)
  return d
}

// Week starts on Monday and ends on Sunday.
export const getWeekStartMonday = (date) => {
  const d = startOfDay(date)

  // JS: Sunday=0 ... Saturday=6
  // Convert so that Monday=0 ... Sunday=6
  const daysSinceMonday = (d.getDay() + 6) % 7

  return addDays(d, -daysSinceMonday)
}
